import appInsights from "@/services/azureApplicationInsights.js";

export default {
  install(app) {
    app.config.globalProperties.$telemetry = appInsights;
  },
};
